import { Row, Col, Navbar, Nav } from "react-bootstrap";
import "./App.css";
import styles from "./App.module.css";
import { useState, useEffect, useRef } from "react";
import { useTheme } from "./ThemeContext";
import { useLang } from "./LangContext";

function BurgerButton({ setMobMenu, setMobServices }) {
  const [isActive, setIsActive] = useState(false);
  const { s, toggleTheme } = useTheme();

  const toggleBurger = () => {
    setIsActive((prev) => !prev);
  };

  return (
    <button
      className={styles.menuBtn}
      onClick={() => {
        setMobMenu((state) => !state);
        setMobServices(false);
        toggleBurger();
      }}
    >
      <div className={`${styles.burger} ${isActive ? styles.active : ""}`}>
        <span style={{ backgroundColor: s.navIconsColor }}></span>
        <span style={{ backgroundColor: s.navIconsColor }}></span>
        <span style={{ backgroundColor: s.navIconsColor }}></span>
      </div>
    </button>
  );
}

function NavBarMenu({ setCurPage }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  return (
    <div className={styles.navMenu} style={s.navBar}>
      <Row xs={3} xl={6} className="px-4">
        <Col>
          <Row xs={1} className="gy-2">
            <Col className={styles.navHeader}>
              {/* <img src="/img/serversIconDark.png" alt="IMG" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 14H19V4H5V14ZM5 16V20H19V16H5ZM4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM15 17H17V19H15V17Z"
                  fill={s.navIconsColor}
                />
              </svg>
              <div className="ms-2" style={s.navMenuHeaders}>
                {t("navHeader1")}
              </div>
            </Col>
            <Col>
              <span
                className={styles.footerLink}
                style={s.navHeaders}
                onClick={() => setCurPage("virtualServers")}
              >
                {t("navHeader1_1")}
              </span>
            </Col>
            <Col>
              <span
                className={styles.footerLink}
                style={s.navHeaders}
                onClick={() => setCurPage("dedicatedServers")}
              >
                {t("navHeader1_2")}
              </span>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row xs={1} className="gy-2">
            <Col className={styles.navHeader}>
              {/* <img src="/img/hostingIconDark.png" alt="IMG" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 11H19V5H5V11ZM21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4ZM19 13H5V19H19V13ZM7 15H10V17H7V15ZM7 7H10V9H7V7Z"
                  fill={s.navIconsColor}
                />
              </svg>
              <div className="ms-2" style={s.navMenuHeaders}>
                {t("navHeader2")}
              </div>
            </Col>
            <Col>
              <span
                className={styles.footerLink}
                style={s.navHeaders}
                onClick={() => setCurPage("virtualHosting")}
              >
                {t("navHeader2_1")}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

{
  /* 
  ТРЕТЬЯ КОЛОНКА "ДРУГИЕ УСЛУГИ"--------------
  
  <Col>
  <Row xs={1} className="gy-2">
    <Col className={styles.navHeader}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"
          fill={s.navIconsColor}
        />
      </svg>
      <div className="ms-2" style={s.navMenuHeaders}>
        {t("navHeader3")}
      </div>
    </Col>
    <Col>
      <span className={styles.footerLink} style={s.navHeaders}>
        {t("navHeader3_1")}
      </span>
    </Col>
  </Row>
</Col>; */
}

function NavBarMenuMobile({ setCurPage }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  return (
    <div>
      <Row
        xs={2}
        className="px-3 gy-4"
        style={{ fontSize: "14px", textAlign: "left" }}
      >
        <Col>
          <Row xs={1} className="gy-2">
            <Col className={styles.navHeader} style={{ fontSize: "17px" }}>
              {/* <img src="/img/serversIconDark.png" alt="IMG" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 14H19V4H5V14ZM5 16V20H19V16H5ZM4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM15 17H17V19H15V17Z"
                  fill={s.navIconsColor}
                />
              </svg>
              <div className="ms-1" style={s.navMenuHeaders}>
                {t("navHeader1")}
              </div>
            </Col>
            <Col>
              <span
                className={styles.footerLink}
                style={s.navHeaders}
                onClick={() => setCurPage("virtualServers")}
              >
                {t("navHeader1_1")}
              </span>
            </Col>
            <Col>
              <span
                className={styles.footerLink}
                style={s.navHeaders}
                onClick={() => setCurPage("dedicatedServers")}
              >
                {t("navHeader1_2")}
              </span>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row xs={1} className="gy-2">
            <Col className={styles.navHeader} style={{ fontSize: "17px" }}>
              {/* <img src="/img/hostingIconDark.png" alt="IMG" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 11H19V5H5V11ZM21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4ZM19 13H5V19H19V13ZM7 15H10V17H7V15ZM7 7H10V9H7V7Z"
                  fill={s.navIconsColor}
                />
              </svg>
              <div className="ms-1" style={s.navMenuHeaders}>
                {t("navHeader2")}
              </div>
            </Col>
            <Col>
              <span
                className={styles.footerLink}
                style={s.navHeaders}
                onClick={() => setCurPage("virtualHosting")}
              >
                {t("navHeader2_1")}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

{
  /*
  ТРЕТИЙ БЛОК "ДРУГИЕ УСЛУГИ" ----------------
  
  <Col>
  <Row xs={1} className="gy-2">
    <Col className={styles.navHeader} style={{ fontSize: "17px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"
          fill={s.navIconsColor}
        />
      </svg>
      <div className="ms-1" style={s.navMenuHeaders}>
        {t("navHeader3")}
      </div>
    </Col>
    <Col>
      <span className={styles.footerLink} style={s.navHeaders}>
        {t("navHeader3_1")}
      </span>
    </Col>
  </Row>
</Col>; */
}

export default function NavBarModule({
  setIsOpened,
  isOpened,
  isSm,
  isXs,
  setCurPage,
}) {
  const [isMobMenu, setMobMenu] = useState(false);
  const [isMobServices, setMobServices] = useState(false);
  const [isLangOpen, setLangOpen] = useState(false);
  const { s, toggleTheme } = useTheme();
  const { lang, changeLang, t } = useLang();

  const langMenuRef = useRef(null);
  // Создаем ref для кнопки переключения языка
  const langButtonRef = useRef(null);

  // Обработчик клика по документу
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isLangOpen &&
        langMenuRef.current &&
        !langMenuRef.current.contains(event.target) &&
        langButtonRef.current &&
        !langButtonRef.current.contains(event.target)
      ) {
        setLangOpen(false);
      }
    };

    // Используем pointerdown — он покрывает и мышь, и тач, и стилус
    // И ставим захват (capture), чтобы отловить событие до любых stopPropagation()
    document.addEventListener("pointerdown", handleClickOutside, true);

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside, true);
    };
  }, [isLangOpen]);

  const navStyle =
    (!(isXs || isSm) && isOpened) || ((isXs || isSm) && isMobMenu)
      ? { borderRadius: "14px 14px 0 0" }
      : {};

  const btnMarginStyle = isSm || isXs ? { marginLeft: "-6px" } : {};

  return (
    <div
      className={`${styles.navbarWrapper} mb-4`}
      style={{ ...navStyle, ...s.navBar }}
    >
      {/* Заставляем Navbar занимать всю высоту родителя */}
      <Navbar
        className="d-flex justify-content-between align-items-center"
        style={{ height: "100%" }}
      >
        <Nav>
          {isSm || isXs ? (
            <>
              <BurgerButton
                setMobMenu={setMobMenu}
                setMobServices={setMobServices}
              />
              {/* <button
                  className={styles.menuBtn}
                  style={{ marginLeft: "-15px" }}
                >
                  <div className={styles.mobileLogoIcon}>
                    <img src={"/img/logoDark.png"} alt="IMG" />
                  </div>
                </button> */}
              {isMobMenu && (
                <div className={styles.mobileNavMenu} style={s.mobNavMenu}>
                  <Row xs={1} className="gy-3">
                    <Col>
                      <span className={styles.footerLink}>
                        <div
                          style={s.navHeadersNoHover}
                          onClick={() => setCurPage("home")}
                        >
                          {t("navBtnMain")}
                        </div>
                      </span>
                    </Col>
                    <Col>
                      <span
                        onClick={() => setMobServices((prev) => !prev)}
                        style={s.navHeadersNoHover}
                      >
                        {t("navBtnServices")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="6"
                          viewBox="0 0 15 6"
                          fill="none"
                          className={`ms-2 ${styles.arrowIcon}`}
                          style={{
                            transform: isMobServices
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          }}
                        >
                          <path
                            d="M7.49998 5.875L14.5996 2.1164L13.8587 0.717041L7.49998 4.08345L1.14122 0.717041L0.400391 2.1164L7.49998 5.875Z"
                            fill={s.navIconsColor}
                          />
                        </svg>
                      </span>
                    </Col>
                    {isMobServices && (
                      <Col>
                        <NavBarMenuMobile setCurPage={setCurPage} />
                      </Col>
                    )}

                    <Col>
                      <span className={styles.footerLink}>
                        <div
                          style={s.navHeadersNoHover}
                          onClick={() => setCurPage("referral")}
                        >
                          {t("navBtnReferals")}
                        </div>
                      </span>
                    </Col>
                  </Row>
                </div>
              )}
            </>
          ) : (
            <>
              <Nav.Link
                className={styles.navbarBtn}
                style={s.navHeadersNoHover}
                onClick={() => setCurPage("home")}
              >
                {t("navBtnMain")}
              </Nav.Link>
              <div
                onMouseEnter={() => setIsOpened(true)}
                onMouseLeave={() => setIsOpened(false)}
                className={styles.servicesContainer}
              >
                <div className={styles.servicesWrapper}>
                  <Nav.Link
                    className={styles.navbarBtn}
                    style={s.navHeadersNoHover}
                  >
                    {t("navBtnServices")}
                    {/* <img
                        src="/img/navbarArrow.png"
                        alt="Стрелка"
                        className={`ms-2 ${styles.arrowIcon}`}
                      /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="6"
                      viewBox="0 0 15 6"
                      fill="none"
                      className={`ms-2 ${styles.arrowIcon}`}
                    >
                      <path
                        d="M7.49998 5.875L14.5996 2.1164L13.8587 0.717041L7.49998 4.08345L1.14122 0.717041L0.400391 2.1164L7.49998 5.875Z"
                        fill={s.themeIcon}
                      />
                    </svg>
                  </Nav.Link>
                  <div className={styles.navBlock} />
                </div>
                {/* {isOpened && <div className={styles.navMenu}></div>} */}
                {isOpened && <NavBarMenu setCurPage={setCurPage} />}
              </div>
              <Nav.Link
                className={styles.navbarBtn}
                style={s.navHeadersNoHover}
                onClick={() => setCurPage("referral")}
              >
                {t("navBtnReferals")}
              </Nav.Link>
              <div
                className={styles.navLogo}
                onClick={() => setCurPage("home")}
              >
                <Nav.Link>
                  {/* <img src={"/img/logoDark.png"} alt="IMG" /> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="53"
                    height="40"
                    viewBox="0 0 53 40"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M27.1103 20.1407C29.6832 20.0544 31.8868 19.4682 33.7211 18.382C35.727 17.1941 36.7236 15.7759 36.711 14.1273C36.7115 12.4709 35.7158 11.0529 33.7238 9.87334C31.7319 8.69377 29.3373 8.10413 26.5402 8.10445C23.7562 8.09695 21.3612 8.68712 19.3553 9.87495C17.3495 11.0628 16.3462 12.4849 16.3457 14.1413C16.3716 15.7977 17.3739 17.2118 19.3526 18.3836C20.6454 19.1491 22.2154 19.6802 24.0624 19.9769L24.0223 21.8052L27.0701 21.8987L27.1103 20.1407ZM24.1027 18.0314C23.1263 17.8128 22.282 17.4925 21.5697 17.0707C20.1977 16.2583 19.5119 15.2895 19.5123 14.1644C19.5127 13.0393 20.2189 12.0587 21.6309 11.2225C23.043 10.3863 24.699 9.96811 26.5989 9.9679C28.4989 9.96769 30.1349 10.3738 31.5068 11.1862C32.8787 11.9986 33.5645 12.9674 33.5642 14.0925C33.5638 15.2176 32.8576 16.1983 31.4455 17.0344C30.2446 17.7456 28.8129 18.1559 27.1504 18.2655L27.2108 15.0894L24.163 14.996L24.1027 18.0314Z"
                      fill={s.logoColor}
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M30.2266 0.916551C28.1646 -0.305257 24.8202 -0.305555 22.7576 0.915884L1.54664 13.4766C0.513335 14.0885 -0.00220991 14.8909 7.11991e-06 15.6928L0.00440237 24.2958C-0.00356551 25.1022 0.511952 25.9101 1.55095 26.5253L22.7587 39.0841C24.8209 40.3053 28.1644 40.3053 30.2266 39.0841L51.4343 26.5253C52.4909 25.9185 53.0064 25.1181 52.9999 24.3167L52.978 15.6928C52.9783 14.8927 52.4629 14.0924 51.4323 13.4817L30.2266 0.916551ZM30.0861 1.7951C28.0253 0.574021 24.683 0.573723 22.6216 1.79443L4.18125 12.7143C2.12028 13.9347 2.12028 15.9135 4.18125 17.1339L22.6227 28.0544C24.6837 29.2749 28.0252 29.2749 30.0861 28.0544L48.5209 17.1379C50.5814 15.9177 50.5819 13.9395 48.522 12.7189L30.0861 1.7951Z"
                      fill={s.logoColor}
                    />
                  </svg>
                </Nav.Link>
              </div>
            </>
          )}
        </Nav>
        <div className="d-flex align-items-center">
          <button
            className={styles.themeBtn}
            style={{ ...btnMarginStyle, ...s.themeBtn }}
            onClick={toggleTheme}
          >
            {/* <img src={"/img/themeDark.png"} alt="IMG" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 21.9971C6.47715 21.9971 2 17.52 2 11.9971C2 6.47423 6.47715 1.99707 12 1.99707C17.5228 1.99707 22 6.47423 22 11.9971C22 17.52 17.5228 21.9971 12 21.9971ZM12 19.9971C16.4183 19.9971 20 16.4154 20 11.9971C20 7.5788 16.4183 3.99707 12 3.99707C7.58172 3.99707 4 7.5788 4 11.9971C4 16.4154 7.58172 19.9971 12 19.9971ZM7.00035 15.3164C9.07995 15.165 11.117 14.2943 12.7071 12.7042C14.2972 11.1141 15.1679 9.07703 15.3193 6.99743C15.6454 7.21445 15.955 7.46679 16.2426 7.75443C18.5858 10.0976 18.5858 13.8966 16.2426 16.2397C13.8995 18.5829 10.1005 18.5829 7.75736 16.2397C7.46971 15.9521 7.21738 15.6425 7.00035 15.3164Z"
                fill={s.themeIcon}
              />
            </svg>
          </button>
          <div style={{ position: "relative", display: "inline-block" }}>
            <button
              ref={langButtonRef}
              className={styles.langBtn}
              style={{
                ...btnMarginStyle,
                ...s.themeBtn,
              }}
              onClick={() => setLangOpen((prev) => !prev)}
            >
              {t("langBtnFlag")}
            </button>
            <div
              ref={langMenuRef}
              className={styles.langMenu}
              style={{
                height: isLangOpen ? "75px" : "0px",
                transition: "height 0.3s ease",
                overflow: "hidden",
                borderWidth: isLangOpen ? "1px" : "0",
                ...s.langMenu,
                left: isXs || isSm ? "-6px" : "0",
                width: isXs || isSm ? "166px" : "172px",
              }}
              onClick={() => changeLang("ru")}
            >
              <div className={styles.langOptionsContainer}>
                <button
                  className={styles.langOption}
                  style={{
                    "--nav-bg-hover": s.langOptionHover,
                    width: isXs || isSm ? "152px" : "156px",
                  }}
                >
                  <svg
                    width="16"
                    height="12"
                    viewBox="0 0 16 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_270_55150)">
                      <rect width="16" height="12" fill="white" />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0V12H16V0H0Z"
                        fill="#3D58DB"
                      />
                      <mask
                        id="mask0_270_55150"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="12"
                        style={{ maskType: "luminance" }}
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0 0V12H16V0H0Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask0_270_55150)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0 0V4H16V0H0Z"
                          fill="#F7FCFF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0 8V12H16V8H0Z"
                          fill="#C51918"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_270_55150">
                        <rect width="16" height="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <span style={s.defText}>Русский</span>
                </button>
                <button
                  className={styles.langOption}
                  onClick={() => changeLang("en")}
                  style={{
                    "--nav-bg-hover": s.langOptionHover,
                    width: isXs || isSm ? "152px" : "156px",
                  }}
                >
                  <svg
                    width="16"
                    height="12"
                    viewBox="0 0 16 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_270_55071)">
                      <rect width="16" height="12" fill="white" />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0 0H16V12H0V0Z"
                        fill="#E31D1C"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0 1V2H16V1H0ZM0 3V4H16V3H0ZM0 6V5H16V6H0ZM0 7V8H16V7H0ZM0 10V9H16V10H0ZM0 12V11H16V12H0Z"
                        fill="#F7FCFF"
                      />
                      <rect width="9" height="7" fill="#2E42A5" />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.04005 2.17381L1.56997 1.80468L1.98103 2.10061H1.74829L2.21896 2.51691L2.05999 3.10061H1.811L1.56923 2.56451L1.36305 3.10061H0.748291L1.21896 3.51691L1.04005 4.17381L1.56997 3.80468L1.98103 4.10061H1.74829L2.21896 4.51691L2.05999 5.10061H1.811L1.56923 4.56451L1.36305 5.10061H0.748291L1.21896 5.51691L1.04005 6.17381L1.56997 5.80468L2.08271 6.17381L1.92329 5.51691L2.33506 5.10061H2.14514L2.56997 4.80468L2.98103 5.10061H2.74829L3.21896 5.51691L3.04005 6.17381L3.56997 5.80468L4.08271 6.17381L3.92329 5.51691L4.33506 5.10061H4.14514L4.56997 4.80468L4.98103 5.10061H4.74829L5.21896 5.51691L5.04005 6.17381L5.56997 5.80468L6.08271 6.17381L5.92329 5.51691L6.33506 5.10061H6.14514L6.56997 4.80468L6.98103 5.10061H6.74829L7.21896 5.51691L7.04005 6.17381L7.56997 5.80468L8.08271 6.17381L7.92329 5.51691L8.33506 5.10061H7.811L7.56923 4.56451L7.36305 5.10061H7.06494L6.92329 4.51691L7.33506 4.10061H7.14514L7.56997 3.80468L8.08271 4.17381L7.92329 3.51691L8.33506 3.10061H7.811L7.56923 2.56451L7.36305 3.10061H7.06494L6.92329 2.51691L7.33506 2.10061H7.14514L7.56997 1.80468L8.08271 2.17381L7.92329 1.51691L8.33506 1.10061H7.811L7.56923 0.564514L7.36305 1.10061H6.74829L7.21896 1.51691L7.05999 2.10061H6.811L6.56923 1.56451L6.36305 2.10061H6.06494L5.92329 1.51691L6.33506 1.10061H5.811L5.56923 0.564514L5.36305 1.10061H4.74829L5.21896 1.51691L5.05999 2.10061H4.811L4.56923 1.56451L4.36305 2.10061H4.06494L3.92329 1.51691L4.33506 1.10061H3.811L3.56923 0.564514L3.36305 1.10061H2.74829L3.21896 1.51691L3.05999 2.10061H2.811L2.56923 1.56451L2.36305 2.10061H2.06494L1.92329 1.51691L2.33506 1.10061H1.811L1.56923 0.564514L1.36305 1.10061H0.748291L1.21896 1.51691L1.04005 2.17381ZM7.05999 4.10061L7.21896 3.51691L6.74829 3.10061H6.98103L6.56997 2.80468L6.14514 3.10061H6.33506L5.92329 3.51691L6.06494 4.10061H6.36305L6.56923 3.56451L6.811 4.10061H7.05999ZM5.98103 4.10061L5.56997 3.80468L5.14514 4.10061H5.33506L4.92329 4.51691L5.06494 5.10061H5.36305L5.56923 4.56451L5.811 5.10061H6.05999L6.21896 4.51691L5.74829 4.10061H5.98103ZM4.21896 4.51691L4.05999 5.10061H3.811L3.56923 4.56451L3.36305 5.10061H3.06494L2.92329 4.51691L3.33506 4.10061H3.14514L3.56997 3.80468L3.98103 4.10061H3.74829L4.21896 4.51691ZM4.36305 4.10061H4.06494L3.92329 3.51691L4.33506 3.10061H4.14514L4.56997 2.80468L4.98103 3.10061H4.74829L5.21896 3.51691L5.05999 4.10061H4.811L4.56923 3.56451L4.36305 4.10061ZM3.05999 4.10061L3.21896 3.51691L2.74829 3.10061H2.98103L2.56997 2.80468L2.14514 3.10061H2.33506L1.92329 3.51691L2.06494 4.10061H2.36305L2.56923 3.56451L2.811 4.10061H3.05999ZM6.21896 2.51691L6.05999 3.10061H5.811L5.56923 2.56451L5.36305 3.10061H5.06494L4.92329 2.51691L5.33506 2.10061H5.14514L5.56997 1.80468L5.98103 2.10061H5.74829L6.21896 2.51691ZM3.98103 2.10061L3.56997 1.80468L3.14514 2.10061H3.33506L2.92329 2.51691L3.06494 3.10061H3.36305L3.56923 2.56451L3.811 3.10061H4.05999L4.21896 2.51691L3.74829 2.10061H3.98103Z"
                        fill="#F7FCFF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_270_55071">
                        <rect width="16" height="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <span style={s.defText}>English</span>
                </button>
              </div>
            </div>
          </div>
          <a href="https://my.qwins.co">
            <button className={styles.loginBtn} style={btnMarginStyle}>
              {t("navBtnLogin")}
            </button>
          </a>
        </div>
      </Navbar>
    </div>
  );
}
